import { IAppAction } from "../appAction";
import { IExperimentList } from "services/types";

export const experimentsActions = {
  FETCH_EXPERIMENTS: "FETCH_EXPERIMENTS",
  FETCH_EXPERIMENTS_SUCCESS: "FETCH_EXPERIMENTS_SUCCESS",
  FETCH_EXPERIMENTS_ERROR: "FETCH_EXPERIMENTS_ERROR",
};

export const fetchExperiments = (): IAppAction => ({
  type: experimentsActions.FETCH_EXPERIMENTS
});

export const fetchExperimentsSuccess = (payload: IExperimentList): IAppAction => ({
  type: experimentsActions.FETCH_EXPERIMENTS_SUCCESS,
  payload
});

export const fetchExperimentsError = (error: Error): IAppAction => ({
  type: experimentsActions.FETCH_EXPERIMENTS_ERROR,
  error
});
